export default "__VITE_ASSET__WVz1zFuE__"